<template>
	<section>

		<h3>
			Mon compte
		</h3>

		<section class="mb-3">
			<div class="row">
				<div class="col-md-12">
					<div class="d-flex flex-row w-100 mb-2"> 
						<h4 class="flex-grow-1 mb-0">
							Programme de parrainage
						</h4>
					</div>
					<div class="alert alert-light">
						<div v-for="(enduser, indexEnduser) in endusers" :key="indexEnduser" class="mb-4">

							<h6>Code pour le Kit Emotivi de {{ enduser.en_fullname }}</h6>
								<span class="referral-code">
									{{ enduser.en_referral_code }}
								</span>
						</div>

					</div>
				</div>
			</div>		
		</section>

		<form-contact v-if="row_co.co_id" :row_co="row_co" />

	</section>
</template>

<script>

import FormContact from "./FormContact";

export default {
	name: "privateaccount",
	components: { FormContact },
	data() {
		return {
			row_co: {},
			endusers: [],
			parcels: []
		};
	},

	async mounted() {
		this.loadAccount();
		// efface les données de paiement !!!
		this.$store.commit("set_co_webaccesstoken_temp", "");
	},
	computed: {
		hasPayment() {
			return this.$store.state.user.endusers &&
				Array.isArray(this.$store.state.user.endusers) &&
				this.$store.state.user.endusers.length
					? true
					: false;
		},
		hasBoxes() {
			return this.$store.state.user.endusers &&
				Array.isArray(this.$store.state.user.endusers) &&
				this.$store.state.user.endusers.length
					? this.$store.state.user.endusers.filter(enduser => {
						return enduser.bo_id;
					}).length
					: 0;
		},
		hasTvs() {
			return this.$store.state.user.endusers &&
				Array.isArray(this.$store.state.user.endusers) &&
				this.$store.state.user.endusers.length
					? this.$store.state.user.endusers.filter(enduser => {
						return enduser.de_id;
					}).length
					: 0;
		}
	},
	methods: {

		async loadAccount() {

			let response = await this.$axios.get(
				this.$config.server_url + "/web/2.0/account"
			);

			this.row_co = response.data.data.row_co;
			this.parcels = response.data.data.parcels;
			this.endusers = response.data.data.endusers;
		}

}
};
</script>

<style lang="scss" scoped>
	.referral-code {
		display: inline-block;
		padding: 5px 10px;
		background-color: #F0F0F0;
		border: 1px solid #a0a0a0;
	}
</style>
